/**
 * TXIBlending enum.
 * 
 * KotOR JS - A remake of the Odyssey Game Engine that powered KotOR I & II
 * 
 * @file TXIBlending.ts
 * @author KobaltBlu <https://github.com/KobaltBlu>
 * @license {@link https://www.gnu.org/licenses/gpl-3.0.txt|GPLv3}
 * @enum
 */
export enum TXIBlending {
  'NONE'= 0,
  'ADDITIVE'= 1,
  'PUNCHTHROUGH'= 2
}